export { default as NotificationsInbox } from './NotificationsInbox';
